exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-image {\n  padding: 30px 20px 30px 20px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n}\n.block-image .image-centered {\n  align-items: center;\n}\n.block-image .image-centered > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.block-image.preview.image-centered > img {\n  object-fit: cover;\n  width: 10px;\n}", ""]);

// exports
